import React from 'react'

const SingleVisit = ({
    id,
    lat,
    long,
    employe,
    sb_employe_id,
    sb_branch_device_id,
    hr_attendance_id,
    type,
    operation,
    start_date,
    end_date,
    note,
    out_lat,
    out_long,
    out_sb_branch_device_id,
    out_type,
    out_operation,
    out_note

}) => {
  return (
    <tr>
        <td>{id}</td>
        <td>{lat}</td>
         <td>{long}</td>
        <td>{type}</td>
        <td>{operation}</td>
        <td>{start_date}</td> 
        <td>{end_date}</td>
    </tr>
  )
}

export default SingleVisit